<kiene-kiene-table [tableDescriptor]="tableDescriptor">
    <div toolbarElementCenter>
        <div *ngIf="dateRange?.zeit_von">
            <mat-chip-list>
                <mat-chip (removed)="resetDateRangeFilter()">
                    <span
                        >Filter: {{ dateRange?.zeit_von | date: "dd.MM.yyyy" }} -
                        {{ dateRange?.zeit_bis | date: "dd.MM.yyyy" }}</span
                    >
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip>
            </mat-chip-list>
        </div>
    </div>
</kiene-kiene-table>
